// GERADO de backend-senne/src/contracts — NÃO editar; rode scripts/sync-contracts.sh

import { z } from 'zod'

/** Envelope de erro padrão do backend-senne. */
export const errorEnvelopeSchema = z.object({
  statusCode: z.number(),
  error: z.string(),
  message: z.string(),
  path: z.string().optional(),
  method: z.string().optional(),
  details: z.union([z.string(), z.array(z.string())]).optional(),
})
export type ErrorEnvelope = z.infer<typeof errorEnvelopeSchema>

/**
 * 403 de ESCOPO, não de capacidade: a pessoa tem a permissão — só não no
 * hospital ativo. O corpo lista os hospitais em que ela TEM (é o acesso do
 * próprio ator, não vaza nada de terceiros) para a tela oferecer a troca em vez
 * de negar em silêncio.
 */
export const FORBIDDEN_AT_HOSPITAL = 'FORBIDDEN_AT_HOSPITAL'

export const forbiddenAtHospitalSchema = z.object({
  error: z.literal(FORBIDDEN_AT_HOSPITAL),
  capability: z.string(),
  hospitalsWithAccess: z.array(
    z.object({ id: z.number(), name: z.string(), uuid: z.string() })
  ),
})
export type ForbiddenAtHospital = z.infer<typeof forbiddenAtHospitalSchema>
